import { PLAN_STATE, type PlanState } from "@next-platform/client-common-core";
import { Button, Icon, IconSize, IconVariants, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { UserRole } from "@next-platform/packages-ts-types";

import { Row } from "@/components/customComponents";
import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";
import { getPlanDisplayColors } from "@/constants/planTierColors";
import { cn } from "@/utils";

type SubscriptionPlanFooterProps = {
  planState: PlanState;
  planRole: UserRole;
};

const SubscriptionPlanFooter = ({ planState, planRole }: SubscriptionPlanFooterProps) => {
  if (planState === PLAN_STATE.EXPIRED) {
    const tierColors = getPlanDisplayColors({ role: planRole, planState: PLAN_STATE.ONE_TIME_ACTIVE });

    return (
      <Button
        as={LocalizedLink}
        to={ROUTES.subscribe}
        size="large"
        variant="Transparent"
        className={cn("w-full bg-gradient-to-b text-white", tierColors.iconBadgeFrom, tierColors.iconBadgeTo)}
        iconStart={tierColors.icon}
        data-testid="SubscriptionPlan-FooterRenewButton"
      >
        <Trans i18nKey="subscription:overview.expired.renewCta" />
      </Button>
    );
  }

  return (
    <Row align="center" className="gap-2 rounded-xl bg-gray-2/50 px-4 py-3" data-testid="SubscriptionPlan-FooterInfo">
      <Icon icon={IconVariants.INFO} size={IconSize.XSMALL} className="text-gray-11" />
      <Text variant={TextVariants.PARAGRAPH_XSMALL_REGULAR} className="text-gray-11">
        <Trans i18nKey="subscription:overview.informationalFooter" />
      </Text>
    </Row>
  );
};

export default SubscriptionPlanFooter;
